import { OrganizationControllerApiFactory } from '@api-client/api'
import { QueryKey } from '@helpers/enums'
import { useQuery } from '@tanstack/react-query'

import { useAsyncApi } from './useAsyncApi'

const useOwnOrganization = () => {
	const organizationControllerApi = useAsyncApi(
		OrganizationControllerApiFactory
	)
	return useQuery({
		queryKey: [QueryKey.GetOwnOrganization],
		queryFn: () => organizationControllerApi(api => api.getOwnOrganisation()),
	})
}

export { useOwnOrganization }
